export default function RevealAnimations() {
  let observer = null;
  const staggerCandidateSelector = [
    'article',
    'li',
    '[class$="__item"]',
    '[class*="__item "]',
    '[class$="__card"]',
    '[class*="__card "]',
    '[class$="__slide"]',
    '[class*="__slide "]',
  ].join(',');

  const getStaggerItems = (container) => {
    const explicitRevealItems = [...container.querySelectorAll('.reveal-fade-up, .reveal-fade-left')];
    const autoRevealItems = [...container.querySelectorAll(staggerCandidateSelector)];
    const items = [...new Set([...explicitRevealItems, ...autoRevealItems])];

    autoRevealItems.forEach((element) => {
      element.classList.add('reveal-fade-up');
    });

    return items.filter((element) => {
      const revealParent = element.parentElement
        ? element.parentElement.closest('.reveal-fade-up, .reveal-fade-left')
        : null;

      return !revealParent || !container.contains(revealParent);
    });
  };

  const applyStaggerDelays = () => {
    document.querySelectorAll('.reveal-stagger').forEach((container) => {
      const rows = [];

      getStaggerItems(container)
        .map((element) => ({
          element,
          rect: element.getBoundingClientRect(),
        }))
        .filter((item) => item.rect.width && item.rect.height)
        .sort((a, b) => {
          if (Math.abs(a.rect.top - b.rect.top) > 12) {
            return a.rect.top - b.rect.top;
          }

          return a.rect.left - b.rect.left;
        })
        .forEach((item) => {
          const row = rows.find((currentRow) => Math.abs(currentRow.top - item.rect.top) <= 12);

          if (row) {
            row.items.push(item);
            row.top = (row.top + item.rect.top) / 2;
            return;
          }

          rows.push({
            top: item.rect.top,
            items: [item],
          });
        });

      rows.forEach((row) => {
        row.items
          .sort((a, b) => a.rect.left - b.rect.left)
          .forEach((item, index) => {
            item.element.style.setProperty('--reveal-delay', `${index * 140}ms`);
          });
      });
    });
  };

  const observeRevealElements = () => {
    applyStaggerDelays();

    const allRevealElements = [
      ...new Set(document.querySelectorAll('.reveal-fade-up:not(.is-visible), .reveal-fade-left:not(.is-visible)')),
    ];

    if (!allRevealElements.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      allRevealElements.forEach((element) => {
        element.classList.add('is-visible');
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -14% 0px',
        threshold: 0.08,
      });
    }

    allRevealElements.forEach((element) => {
      observer.observe(element);
    });
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      observeRevealElements();
    });
  });

  document.addEventListener('codelibry:reveal-refresh', () => {
    requestAnimationFrame(observeRevealElements);
  });

  window.addEventListener('resize', () => {
    requestAnimationFrame(applyStaggerDelays);
  });
}
